import { NotFound } from 'ui-components';

type SearchEngineErrorProps = {
  title?: string;
  description?: string;
};

export const SearchEngineError = ({
  title = 'Something went wrong',
  description = "We couldn't load the search results. Please try refreshing the page.",
}: SearchEngineErrorProps) => (
  <NotFound variant="server-error" title={title} description={description} />
);
